<template>
  <div style="margin-bottom: 120px; z-index: 1;">
    <b-navbar
      toggleable="lg"
      type=""
      variant=""
      fixed="top"
      style="z-index: 1; background-color: white;margin-right:20px !important"
    >
      <b-navbar-brand to="" @click="onHomeCLick()" style="cursor: pointer">
        <img
          src="@/assets/images/eG_LOGO.jpg"
          class="d-inline-block align-top logo"
          style="width: auto; height: 100%; padding: 15px"
          alt="eGalleria"
        />
      </b-navbar-brand>
      <div @click="handleCartClick()" class="cart c1 mr-0 my-auto">
        <b-icon
          class="h4"
          icon="cart3"
          style="color: #0c0f66; cursor: pointer"
        ></b-icon>
        <label class="rounded-circle">{{ getCartCount }}</label>
      </div>
      <b-navbar-toggle
        target="navbar-toggle-collapse"
        style="z-index: 1000; background-color: white"
      >
        <template v-slot:default="{ expanded }">
          <b-icon v-if="expanded" icon="x" style="z-index: 1000"></b-icon>
          <b-icon
            v-else
            icon="list"
            style="z-index: 1000; background-color: none"
          ></b-icon>
        </template>
      </b-navbar-toggle>
      <b-collapse id="navbar-toggle-collapse" is-nav>
        <b-navbar-nav class="mx-auto">
          <b-nav-item link-classes="nav_link" @click="onHomeCLick()" to=""
            >Home</b-nav-item
          >
          <b-nav-item link-classes="nav_link" to="/exhibition/"
            >Exhibitions</b-nav-item
          >
          <b-nav-item
            link-classes="nav_link"
            @click="methodThatForcesUpdate()"
            to="/explore-art/"
            >Explore Art</b-nav-item
          >
          <!-- <b-nav-item link-classes = "nav_link" to="/our-artists/">Our Artists</b-nav-item> -->
          <!-- <b-nav-item link-classes = "nav_link" to="/art-stories/">Art Stories</b-nav-item> -->

          <div @click="handleCartClick()" class="cart c2 mx-auto my-auto">
            <b-icon
              class="h4 cart-icon"
              icon="cart3"
              style="color: #0c0f66; cursor: pointer"
            ></b-icon>
            <label class="rounded-circle">{{ getCartCount }}</label>
          </div>
          <button
            size="lg"
            v-if="!isAuthenticated"
            class="login-register-btn"
            @click="loginPage"
            type=""
          >
            Login/Register
          </button>
          <div v-else class="userprofile dropdown">
            <p style="display: inline-block" class="name">Hi, {{ userName }}</p>
            <b-img-lazy
              rounded="circle"
              style="display: inline-block; vertical-align: top"
              class="profile_image"
              :src="user_image"
            >
            </b-img-lazy>

            <div class="dropdown-menu">
              <router-link class="" to="/myaccount/">My Account</router-link>
              <router-link class="" to="/logout/">Log Out</router-link>
            </div>
          </div>
          <a  v-if="isAuthenticated && isArtist" href="https://artist.egalleria.in/" target="_blank">
          <button
            size="lg"
            v-if="isAuthenticated && isArtist"
            class="login-register-btn"
          >
            Artist Dashboard
          </button>
          </a>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import { store } from "../../store/store.js";

export default {
  name: "Navbar",
  props: [],
  data() {
    return {
      otp_sent: false,
      fetch_loader: false,
      phone_number_verification_code: "",
      verification_message: "Please click here to verify your phone number: ",
      user_name: "",
      user_avatar: "",
    };
  },

  methods: {
    handleCartClick() {
      if (this.getCartCount) {
        this.$router.push("/checkout/");
      } else {
        this.$notify({
          group: "error",
          title: "Empty Cart",
          text: "Your Cart is Empty",
        });
      }
    },
    onHomeCLick() {
      if (this.$store.getters.isAuthenticated) this.$router.push("/home/");
      else this.$router.push("/");
    },

    methodThatForcesUpdate() {
      this.$parent.$emit("reloadView", "clicked");
    },

    load_cart() {
      this.$store
        .dispatch("getCartData")
        .then((res) => {
          if (res.cart_items) this.cart_count = res.cart_items.length;

          this.$store.commit("setCartList", res);
        })
        .catch((err) => {
          this.fetch_loader = false;
          this.$notify({
            group: "error",
            title: "Error Loading Cart",
            text: "Something Went Wrong",
          });
        });
    },

    // sendOTP() {
    //   this.fetch_loader = true;
    //   this.$store
    //     .dispatch("sendOTP")
    //     .then(res => {
    //       this.otp_sent = true;
    //       this.fetch_loader = false;
    //       this.verification_message = "Verification OTP has been sent through SMS !!!"
    //     })
    //     .catch(err => {
    //       this.fetch_loader = false;
    //       this.$notify({
    //         group: "error",
    //         title: "Error",
    //         text: "Something Went Wrong",
    //       });
    //     });
    // },
    // sendEnteredOTP() {
    //   this.fetch_loader = true;

    //   let json_data = {};
    //   json_data[
    //     "phone_number_verification_code"
    //   ] = this.phone_number_verification_code;

    //   this.$store
    //     .dispatch("sendEnteredOTP", json_data)
    //     .then(res => {
    //       this.$store.state.profile.phone_number_verified = true;
    //       this.$notify({
    //         group: "success",
    //         title: "Success",
    //         text: "Phone number Successfully verified !!!",
    //       });
    //     })
    //     .catch(err => {
    //       this.fetch_loader = false;
    //       this.$notify({
    //         group: "error",
    //         title: "Error",
    //         text: "Something Went Wrong",
    //       });
    //     });
    // },
    // artistRegisterationPage() {
    //   this.$router.push("/artist-registeration/");
    // },
    loginPage() {
      this.$router.push("/login/");
    },
  },
  computed: {
    getCartCount() {
      let cart_item_count = 0;
      if (this.isAuthenticated) {
        let cart_list = this.$store.getters.getCartList;
        cart_item_count = cart_list.cart_items
          ? cart_list.cart_items.length
          : 0;
        return cart_item_count;
      } else {
        let cart_list = JSON.parse(localStorage.getItem("cart"));
        if (cart_list)
          cart_item_count = cart_list.cart_items
            ? cart_list.cart_items.length
            : 0;
        return cart_item_count;
      }
    },

    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    isArtist(){
      let profile = this.$store.getters.getProfile;
      if (profile && profile.user_profile)
        return profile.user_profile.is_artist
      return false;
    },
    userName() {
      let profile = this.$store.getters.getProfile;
      if (profile)
        return "user" in profile
          ? profile.user.full_name
          : profile.user_profile.user.full_name;
      return "";
    },
    user_image() {
      let profile = this.$store.getters.getProfile;
      if (profile)
        return "user" in profile ? profile.avatar : profile.user_profile.avatar;
      return "";
    },
  },
  created() {
    if (this.$store.getters.getCartList) {
      if (this.isAuthenticated) this.load_cart();
    }
  },

  mounted() {
    if (this.isAuthenticated) {
      let cart_list = this.$store.getters.getCartList;
      this.cart_count = cart_list.cart_items ? cart_list.cart_items.length : 0;
    } else {
      this.cart_count = 0;
    }
  },
};
</script>

<style scoped>
.c1 {
  display: none;
}
#close {
  display: none;
}
.profile_image {
  margin: -15px 20px;
  width: 50px;
  height: 50px;
}

.userprofile {
  left: 10px;
  top: 25px;
  position: relative;
}

.userprofile p {
  overflow: hidden;
  white-space: nowrap;
  line-height: 22px;
  margin-top: -3.5px;
  font-family: "Titillium Web", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  color: rgba(12, 15, 102, 1);
  letter-spacing: -0.04px;
}

.custom-registeration-button {
  border-color: rgba(0, 0, 0, 0.3);
  background-color: white;
  padding: 18px;
  border-width: 0.3px;
  font-weight: 1000px;
  font-size: 16px;
  margin-right: 5px;
}

.custom-registeration-button:hover {
  background-color: #fc4f4f;
  color: #fff;
  border: none;
}

.social-media-icons {
  position: absolute;
  bottom: 40px;
}
.sticky-nav {
  padding: 20px;
  height: 80px;
  background-color: brown;
  /* text-align:center; */
}

.dropdown:hover > .dropdown-menu {
  display: block;
  top: 30px;
  padding: 10px 10px !important;
  height: auto;
  margin: 15px;
  background-color: #0c0f66;
}

.dropdown-menu {
  display: inline-block !important;
  background-color: #ffffff;
  color: #ffffff;
  padding: 0px !important;
  width: 10% !important;
  justify-content: center !important;
  align-items: center !important;
  text-align: center;
  top: 0px;
  height: 0px;

  position: absolute;
  margin-top: 0px;
  overflow: hidden;
  transition: all 0.2s linear;
  border: transparent !important;
}
.dropdown:hover > .dropdown-menu > a {
  display: inline-block;
  width: 100%;
  height: 5vh;
  text-decoration: none;
  color: #ffffff;
  margin: auto;
  transition: all linear;
}
.dropdown:hover > .dropdown-menu > a:hover {
  text-decoration: underline;
  font-size: large;
}

.cart {
  padding: 1.5rem 0rem;
  margin: auto;
}
.cart > label {
  background-color: #0c0f66;
  color: #ffffff;
  position: relative;
  top: -2em;
  font-size: x-small;
  left: -0.4rem;
  padding: 0 2px;
}
#sidebar {
  display: none;
}

.b-sidebar > .b-sidebar-header {
  background-color: #0c0f66 !important;
}
@media only screen and (max-width: 600px) {
  .sticky-nav {
    padding: 20px;
    height: 150px;
    background-color: brown;
    /* text-align:center; */
  }
}

.sticky-nav-p-tag {
  margin-top: 10px;
  margin-bottom: 10px;
  color: white;
  font-size: 18px;
  float: right;
  font-weight: bold;
}
.phone-number-verification-input {
  border-radius: 10px;
}

.phone-number-verification-input:focus {
  background-color: white;
}

.custom-button {
  float: right;
  margin-left: 10px;
}
@media(min-width: 992px){
  .logo{
    margin-left: 30%;
  }
}
@media (max-width: 992px) {
  #close {
    display: inline;
  }
  .navbar-collapse {
    position: absolute;
    right: 0;
    top: 0;
    padding: 15px;
    width: 75%;
    height: 100vh;
    max-height: 100vh;
    background-color: #0c0f6608;
    display: inline;
    color: #ffffff;
    z-index: 100;
  }
  .navbar-collapse.collapsing {
    right: -65%;
    transition: height 0s ease;
    color: #ffffff;
  }
  .navbar-collapse.show {
    right: 0;
    transition: right 100ms ease-in-out;
    background-color: #0c0f66;
    color: #ffffff;
  }
  .navbar-toggler.collapsed ~ .navbar-collapse {
    transition: right 100ms ease-in-out;
    color: #ffffff;
  }
  a.nav-link.nav_link {
    color: #ffffff;
  }
  .navbar {
    padding: 0px;
  }
  .cart-icon {
    color: #ffffff !important;
  }
  .c1 {
    display: inline;
    /* margin-bottom: -30px; */
  }
  .c2 {
    display: none;
  }
  .name {
    color: #fff !important;
  }
}
/* side bar */
/* @media only screen and (max-width: 990px){
  #b-nav{
    display: none;

  }
  #sidebar{
    display: block;
  }
} */
</style>

